import get from 'lodash.get';

export const sortIsoString = (rowA, rowB, columnId) => {
  const isoStringA = get(rowA, ['original', columnId]);
  const isoStringB = get(rowB, ['original', columnId]);
  // eslint-disable-next-line no-nested-ternary
  return isoStringA < isoStringB ? -1 : isoStringA > isoStringB ? 1 : 0;
};
